import React from 'react';
import { useIntl } from 'react-intl';
import { Form, Modal } from 'antd';

import PaymentConditionForm from '../PaymentConditionForm';
import { CreatePaymentConditionRequest } from '@/core/domain/enterprise/PaymentCondition/PaymentCondition.types';
import { usCreatePaymentCondition } from '@/core/domain/enterprise/PaymentCondition/PaymentCondition.hooks';

interface Props {
  visible: boolean;
  handleVisible: () => void;
}

const CreatePaymentConditionModal = ({ visible, handleVisible }: Props) => {
  const intl = useIntl();
  const [form] = Form.useForm();

  const createMutation = usCreatePaymentCondition();

  const handleOk = async () => {
    try {
      const values = await form.validateFields();

      const obj: CreatePaymentConditionRequest = {
        ...values,
        active: true,
      };

      await createMutation.mutateAsync(obj);

      handleCancel();
    } catch {}
  };

  const handleCancel = () => {
    form.resetFields();

    handleVisible();
  };

  return (
    <Modal
      title={intl.formatMessage({ id: 'paymentConditions.create' })}
      visible={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={createMutation.isLoading}
      width={756}
    >
      <PaymentConditionForm form={form} />
    </Modal>
  );
};

export default CreatePaymentConditionModal;
